import { render } from "./HomeInfoSubBlock.vue?vue&type=template&id=0c773ee0&scoped=true&ts=true"
import script from "./HomeInfoSubBlock.vue?vue&type=script&lang=ts"
export * from "./HomeInfoSubBlock.vue?vue&type=script&lang=ts"

import "./HomeInfoSubBlock.vue?vue&type=style&index=0&id=0c773ee0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c773ee0"]])

export default __exports__